import React from 'react';
import { usePhoneViewport } from './usePhoneViewport';

/**
 * Renders its children on a desktop and nothing on a phone (ROADMAP "The phone
 * branch", D4). The phone reads; it does not converse or onboard — so the
 * floating chat and the quiz / welcome / checklist prompts, which mount at the
 * App level rather than in a layout, are wrapped in this.
 */
const DesktopOnly: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  usePhoneViewport() ? null : <>{children}</>;

export default DesktopOnly;
